import {ApiCollection} from "./api.collection";
import {Contact} from "../models/contact.model";


export const Contacts = ApiCollection.extend({
    model: Contact,
    url: 'api/contacts',
});
